import { Dispatch } from "@reduxjs/toolkit";
import {
  BillingAddressState,
  CartState,
  CreateCartState,
} from "../../utils/interfaces/cart";
import { createEmptyCart, setBillingAddress, setCart } from "./reducer";

export const cartActionDispatch = (dispatch: Dispatch) => ({
  setCart: (cart: CartState) => dispatch(setCart(cart)),
  createEmptyCart: (cart: CreateCartState) => dispatch(createEmptyCart(cart)),
  setBillingAddress: (billing_address: BillingAddressState) =>
    dispatch(setBillingAddress(billing_address)),
});
